<template>
	<Head title="Secure Area" />

	<jet-authentication-card>
		<template #logo>
			<jet-authentication-card-logo />
		</template>

		<jet-validation-errors class="mb-4" />

		<form @submit.prevent="submit">
			
			<div class="mt-4">
				<jet-label for="password" value="Password" />
				<jet-input id="password" type="password" class="mt-1 block w-full" v-model="form.password" required autofocus />
			</div>
			<div class="mt-4">
				<jet-label for="password_confirm" value="Confirm Password" />
				<jet-input id="password_confirm" type="password" class="mt-1 block w-full" v-model="form.password_confirm" required />
			</div>

			<div class="flex items-center justify-end mt-4">
				<jet-button class="ml-4" :class="{ 'opacity-25': processing }" :disabled="processing">
					Set Password
				</jet-button>
			</div>
		</form>

	</jet-authentication-card>
</template>

<script>


import { Head } from '@inertiajs/inertia-vue3';
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue'
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue'
import JetLabel from '@/Jetstream/Label.vue'
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue'
import JetButton from '@/Jetstream/Button.vue'
import JetInput from '@/Jetstream/Input.vue'

export default {
	props: {
		user: Object,
	},
	components: {
		Head,
		JetButton,
		JetInput,
		JetAuthenticationCard,
		JetAuthenticationCardLogo,
		JetLabel,
		JetValidationErrors
	},
	data() {
		return {
			form: this.$inertia.form({
				password: '',
				password_confirm: '',
			}),
			processing: false
		}
	},

	methods: {
		submit() {
			this.form
				.transform(data => ({
					...data,
					token: this.user.token
				}))
				.post(`/set-password/${this.user.token}`, {
					onFinish: (res) => {
						// console.log(res)
					}
				})
		}
	}
}
</script>
